import { cloneDeep } from 'lodash';
import { AnyAction } from 'redux';
import { NHCXState } from '../models/nhcxModel';
import actionTypes from '../types/nhcxTypes';

const initialState: NHCXState = {
  payerDropDownVisible: true,
  memberName: '',
  policySearchList: [],
  ipoCorelationId: null,
  memberCorelationId: null,
  ipoResponse: {},
  coverageResponse: {},
  selectedPolicyDetail: 0,
  totalAmount: 0,
  notifyModal: false,
  cardChanged: false,
  showOtpScreen: false,
  participantCreated: false,
  radioValue: 'insurance',          // default
  participantExisting : false,
};
const setPolicySearchResults = (state: NHCXState, { policySearchList }: AnyAction): NHCXState => ({
  ...state, ...{ policySearchList },
});
const clearState = (): NHCXState => cloneDeep(initialState);

const reducer = (
  state: any = initialState,
  action: AnyAction,
): any => {
  switch (action.type) {
    case actionTypes.SET_PAYER_DROPDOWN:
      return {
        ...state,
        payerDropDownVisible: action.payload,
      };
    case actionTypes.SET_MEMBER_NAME:
      return {
        ...state,
        memberName: action.payload,
      };

    case actionTypes.SET_POLICY_SEARCH_RESULTS:
      return setPolicySearchResults(state, action);

    case actionTypes.SET_IPO_ID:
      return {
        ...state,
        ipoCorelationId: action.payload,
      };
    case actionTypes.SET_COVERAGE_ID:
      return {
        ...state,
        memberCorelationId: action.payload,
      };
    case actionTypes.SET_TOTAL_AMOUNT:
      return {
        ...state,
        totalAmount: action.payload,
      };
    case actionTypes.SET_NOTIFY_MODAL:
      return {
        ...state,
        notifyModal: action.payload,
      };

    case actionTypes.SET_IPO_RESPONSE:
      return {
        ...state,
        ipoResponse: action.payload,
      };
    case actionTypes.SET_COVERAGE_RESPONSE:
      return {
        ...state,
        coverageResponse: action.payload,
      };
    case actionTypes.SET_SELECTED_POLICY_DETAIL:
      return {
        ...state,
        selectedPolicyDetail: action.payload,
      };
    case actionTypes.CLEAR_NHCX_STATE:
      return clearState();
    case actionTypes.SET_CARD_CHANGED:
      return {
        ...state,
        cardChanged: action.payload,
      };
    case actionTypes.SET_SHOW_OTP_SCREEN:
      return {
        ...state,
        showOtpScreen: action.payload,
      };
    case actionTypes.SET_PARTICIPATION_CREATED:
      return {
        ...state,
        participantCreated: action.payload,
      };
    case actionTypes.SET_RADIO_VALUE:
      return {
        ...state,
        radioValue: action.payload,
      };
    case actionTypes.SET_IF_PARTICIPANT_EXISTING:
      return {
        ...state,
        participantExisting: action.payload,
      };

    default: return state;
  }
};

export { reducer as nhcxReducer };
